if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        // const formData = new FormData(this.form);
        let formData;
        const add_on_checkbox = document.querySelector("[name='add_on_checkbox']");

        if (add_on_checkbox && add_on_checkbox.checked) {
          formData = new FormData();

          const addProductId = this.form.querySelector('[name="id"]').value;
          const addOnProductId = add_on_checkbox.value;

          formData.append('items[0][id]', addOnProductId);
          formData.append('items[0][quantity]', 1);

          formData.append('items[1][id]', addProductId);
          formData.append('items[1][quantity]', 1);

        } else {
          formData = new FormData(this.form);
        }
        
        // custom code

        // // custom code add on free slot and with BUy1 and Buy2 base quantity
        //   const eligibleVariants = [
        //     '53208378540365',
        //     '53219058745677',
        //     '53208378573133',
        //     '53219058778445'
        //   ];

        //   const addProductId = this.form.querySelector('[name="id"]').value;

        //   let formData;

        //   if (eligibleVariants.includes(addProductId)) {
        //     formData = new FormData();

        //     if(addProductId == '53219058745677' || addProductId == '53219058778445'){
        //       formData.append('items[0][id]', addProductId);
        //       formData.append('items[0][quantity]', 2);

        //       formData.append('items[1][id]', '52355880780109');
        //       formData.append('items[1][quantity]', 2);
        //     } else{
        //       formData.append('items[0][id]', addProductId);
        //       formData.append('items[0][quantity]', 1);

        //       formData.append('items[1][id]', '52355880780109');
        //       formData.append('items[1][quantity]', 1);
        //     }  
        //   } else {
        //     formData = new FormData(this.form);
        //   }
        // // custom code

        // // custom code -- add second at $9
        //   const eligibleVariants = [
        //     '53528859738445',
        //     '53528859771213',
        //     '53528859803981',
        //     '53528859836749'
        //   ];

        //   const addProductId = this.form.querySelector('[name="id"]').value;

        //   let formData;

        //   if (eligibleVariants.includes(addProductId)) {
        //     formData = new FormData();

        //     if(addProductId == '53528859771213' || addProductId == '53528859836749'){
        //       formData.append('items[0][id]', addProductId);
        //       formData.append('items[0][quantity]', 2);

        //       // formData.append('items[1][id]', '52355880780109');
        //       // formData.append('items[1][quantity]', 2);
        //     } else{
        //       formData.append('items[0][id]', addProductId);
        //       formData.append('items[0][quantity]', 1);

        //       // formData.append('items[1][id]', '52355880780109');
        //       // formData.append('items[1][quantity]', 1);
        //     }  
        //   } else {
        //     formData = new FormData(this.form);
        //   }
        // // custom code


        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {

           


            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
